import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import SubscriptionClient from "@/pcm/store/models/SubscriptionClient";

export default class SubscriptionClientSocial extends Model {
    static entity = 'subscription_client_socials';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'username',
    };

    static fields() {
        return {
            id: this.uid(),
            subscription_client_id: this.attr(null),
            username: this.string(''),
            url: this.string(''),
            type: this.string('').nullable(),

            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            subscriptionClient: this.belongsTo(SubscriptionClient, 'subscription_client_id'),
        }
    }

    declare id: number;
    declare subscription_client_id: number;
    declare username: string;
    declare url: string;
    declare type: string | null;

    declare subscriptionClient: SubscriptionClient | null;
}
